export default class ImageGalleryLoading {

    constructor() {
        this.settings = {
            $imageGallery : $("#js-image-gallery")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$imageGallery.length) {

            const imageGallery = document.getElementById('js-image-gallery');
            const loadMoreButton = document.getElementById('load-more');
            const amountToShow = parseInt(imageGallery.getAttribute('data-amount-to-show'));
            let shownImages = amountToShow;
            
            // Load more button functionality - hiding when all images have been displayed
            if (loadMoreButton) {
                loadMoreButton.addEventListener('click', function() {
                    const totalImages = imageGallery.querySelectorAll('div').length;

                    for (let i = shownImages; i < shownImages + amountToShow; i++) {
                        if (i < totalImages) {
                            imageGallery.querySelectorAll('div')[i].style.display = 'block';
                        }
                    }

                    shownImages += amountToShow;

                    if (shownImages >= totalImages) {
                        loadMoreButton.style.display = 'none';
                    }
                });
            }

            // Initially hide images beyond the specified amount to show
            for (let i = amountToShow + 1; i < imageGallery.querySelectorAll('div').length; i++) {
                imageGallery.querySelectorAll('div')[i].style.display = 'none';
            }

        }

    }
};

new ImageGalleryLoading();